/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconArrowDownSquare = createReactComponent("outline", "arrow-down-square", "IconArrowDownSquare", [["path", { "d": "M12 7v14", "key": "svg-0" }], ["path", { "d": "M9 18l3 3l3 -3", "key": "svg-1" }], ["path", { "d": "M14 3v4h-4v-4z", "key": "svg-2" }]]);

export { IconArrowDownSquare as default };
//# sourceMappingURL=IconArrowDownSquare.mjs.map
